var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8201 30.84L14.9001 47.76C14.7871 47.87 14.705 48.0078 14.662 48.1595C14.619 48.3112 14.6167 48.4716 14.6551 48.6245C14.6936 48.7774 14.7716 48.9175 14.8813 49.0308C14.991 49.1441 15.1285 49.2266 15.2801 49.27L19.4901 50.53C19.6334 50.5749 19.7638 50.6538 19.8701 50.76C19.9763 50.8663 20.0552 50.9966 20.1001 51.14L21.3601 55.35C21.4035 55.5016 21.486 55.6391 21.5993 55.7488C21.7126 55.8585 21.8527 55.9365 22.0056 55.9749C22.1585 56.0134 22.3189 56.0111 22.4706 55.9681C22.6223 55.9251 22.7601 55.843 22.8701 55.73L39.7901 38.81L31.8201 30.84Z",
    fill: "#EBA183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.18 30.84L49.1 47.76C49.2129 47.87 49.295 48.0078 49.338 48.1595C49.381 48.3112 49.3834 48.4716 49.3449 48.6245C49.3064 48.7774 49.2284 48.9175 49.1187 49.0308C49.0091 49.1441 48.8715 49.2266 48.72 49.27L44.51 50.53C44.3666 50.5749 44.2362 50.6538 44.13 50.76C44.0237 50.8663 43.9448 50.9966 43.9 51.14L42.64 55.35C42.5965 55.5016 42.514 55.6391 42.4007 55.7488C42.2874 55.8585 42.1473 55.9365 41.9944 55.9749C41.8415 56.0134 41.6812 56.0111 41.5294 55.9681C41.3777 55.9251 41.24 55.843 41.13 55.73L24.21 38.81L32.18 30.84Z",
    fill: "#BC8169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9501 30.0742C52.557 19.6095 45.3764 9.82359 34.9117 8.21666C24.4471 6.60974 14.6612 13.7903 13.0542 24.255C11.4473 34.7196 18.6279 44.5055 29.0926 46.1125C39.5572 47.7194 49.3431 40.5388 50.9501 30.0742Z",
    fill: "#DFE8F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7581 37.175C42.284 34.5464 44.6328 27.9358 42.0041 22.4098C39.3755 16.8838 32.7649 14.5351 27.2389 17.1638C21.713 19.7924 19.3642 26.403 21.9929 31.929C24.6215 37.4549 31.2321 39.8037 36.7581 37.175Z",
    fill: "#F0F4F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumSingle);
export default __webpack_public_path__ + "static/media/premium_single.98d4e45c3c13f78e8084feb68ea16486.svg";
export { ForwardRef as ReactComponent };